var map = {
	"./aari/design-002/Aari-Work-002-100.png": 6575,
	"./aari/design-002/Aari-Work-002-101.png": 3910,
	"./aari/design-002/Aari-Work-002-102.png": 5117,
	"./aari/design-002/Aari-Work-002-103.png": 2084,
	"./aari/design-003/Aari-Work-003-100.jpeg": 9920,
	"./aari/design-003/Aari-Work-003-102.jpeg": 4106,
	"./aari/design-003/Aari-Work-003-103.jpeg": 7153,
	"./aari/design-003/Aari-Work-003-105.jpeg": 7035,
	"./aari/design-004/Aari-Work-004-100.png": 811,
	"./aari/design-004/Aari-Work-004-101.jpeg": 3107,
	"./aari/design-004/Aari-Work-004-103.jpeg": 3837,
	"./aari/design-004/Aari-Work-004-105.png": 7478,
	"./aari/design-004/Aari-Work-004-106.jpeg": 7106,
	"./aari/design-006/Aari-Work-006-100.png": 9031,
	"./aari/design-006/Aari-Work-006-101.png": 6542,
	"./aari/design-006/Aari-Work-006-102.png": 2293,
	"./aari/design-006/Aari-Work-006-103.png": 28,
	"./aari/design-006/Aari-Work-006-104.png": 6275,
	"./aari/design-007/Aari-Work-007-100.jpeg": 7288,
	"./aari/design-007/Aari-Work-007-101.jpeg": 1423,
	"./aari/design-007/Aari-Work-007-102.jpeg": 4274,
	"./all-services/aari.jpeg": 5036,
	"./all-services/alteration.jpeg": 5118,
	"./all-services/blouse.jpeg": 5801,
	"./all-services/half_saree.png": 256,
	"./all-services/kids_dress.jpeg": 3878,
	"./all-services/lehanga.png": 5262,
	"./all-services/saree-falls.png": 5125,
	"./all-services/saree-threading.jpeg": 8480,
	"./all-services/temp/Aari-001-100.jpeg": 3533,
	"./all-services/temp/Alteration-002-101.jpeg": 7977,
	"./all-services/temp/Blouse_Stitching-001-101.jpeg": 8947,
	"./all-services/temp/Blouse_Stitching-001-102.jpeg": 8505,
	"./all-services/temp/kids_dress-001-101.jpeg": 7272,
	"./all-services/thanjavur-painting.png": 4452,
	"./alterations/kids-alterations/kids-dress-alterations-102.jpeg": 7582,
	"./alterations/kids-alterations/kids-dress-alterations-104.jpeg": 8720,
	"./alterations/kids-alterations/kids-dress-alterations-105.jpeg": 8295,
	"./alterations/kids-alterations/kids-dress-alterations-106.jpeg": 7306,
	"./alterations/ladies-alterations/ladies-dress-alterations-003.jpeg": 1812,
	"./alterations/ladies-alterations/ladies-dress-alterations-005.jpeg": 8186,
	"./blouse/design-001/Blouse-001-101.jpeg": 6589,
	"./blouse/design-001/Blouse-001-102.jpeg": 636,
	"./blouse/design-001/Blouse-001-103.jpeg": 2291,
	"./blouse/design-001/Blouse-001-104.jpeg": 6434,
	"./blouse/design-002/Blouse-002-100.jpeg": 6916,
	"./blouse/design-002/Blouse-002-101.jpeg": 251,
	"./blouse/design-002/Blouse-002-103.jpeg": 837,
	"./blouse/design-003/Aari-Work-001-100.png": 8996,
	"./blouse/design-003/Aari-Work-001-101.jpeg": 9714,
	"./blouse/design-003/Aari-Work-001-102.jpeg": 7007,
	"./blouse/designs/blouse-back/blouse-designs-501.jpeg": 6497,
	"./blouse/designs/blouse-back/blouse-designs-503.jpeg": 5255,
	"./blouse/designs/blouse-back/blouse-designs-504.jpeg": 334,
	"./blouse/designs/blouse-back/blouse-designs-505.jpeg": 5893,
	"./blouse/designs/blouse-back/blouse-designs-506.jpeg": 8900,
	"./blouse/designs/blouse-back/blouse-designs-507.jpeg": 1643,
	"./blouse/designs/blouse-back/blouse-designs-508.png": 4013,
	"./blouse/designs/blouse-front/blouse-designs-101.jpeg": 8953,
	"./blouse/designs/blouse-front/blouse-designs-102.jpeg": 808,
	"./blouse/designs/blouse-front/blouse-designs-103.jpeg": 5407,
	"./blouse/designs/blouse-front/blouse-designs-104.jpeg": 9270,
	"./blouse/designs/blouse-front/blouse-designs-105.jpeg": 7933,
	"./blouse/designs/blouse-front/blouse-designs-106.jpeg": 5052,
	"./blouse/designs/blouse-front/blouse-designs-107.jpeg": 7331,
	"./blouse/designs/blouse-front/blouse-designs-108.jpeg": 5002,
	"./blouse/designs/blouse-front/blouse-designs-109.jpeg": 2401,
	"./blouse/designs/blouse-front/blouse-designs-110.jpeg": 6083,
	"./blouse/designs/blouse-front/blouse-designs-111.jpeg": 9148,
	"./blouse/designs/blouse-front/blouse-designs-112.jpeg": 6813,
	"./blouse/designs/blouse-front/blouse-designs-113.jpeg": 8070,
	"./blouse/designs/blouse-front/blouse-designs-114.jpeg": 7599,
	"./blouse/designs/blouse-front/blouse-designs-115.jpeg": 9080,
	"./blouse/designs/blouse-front/blouse-designs-116.jpeg": 409,
	"./blouse/designs/blouse-front/blouse-designs-117.jpeg": 82,
	"./blouse/designs/blouse-front/blouse-designs-118.jpeg": 9755,
	"./blouse/designs/blouse-front/blouse-designs-119.jpeg": 6420,
	"./blouse/designs/blouse-front/blouse-designs-120.jpeg": 6820,
	"./blouse/designs/blouse-front/blouse-designs-121.jpeg": 203,
	"./blouse/designs/blouse-front/blouse-designs-122.jpeg": 9934,
	"./blouse/designs/blouse-front/blouse-designs-123.jpeg": 1893,
	"./blouse/designs/blouse-front/blouse-designs-124.jpeg": 6880,
	"./blouse/designs/blouse-front/blouse-designs-125.jpeg": 1591,
	"./blouse/designs/blouse-front/blouse-designs-126.jpeg": 9338,
	"./blouse/designs/blouse-front/blouse-designs-127.jpeg": 8529,
	"./blouse/designs/blouse-front/blouse-designs-128.jpeg": 5676,
	"./blouse/designs/blouse-front/blouse-designs-129.jpeg": 931,
	"./blouse/designs/blouse-front/blouse-designs-130.jpeg": 7845,
	"./blouse/designs/blouse-front/blouse-designs-131.jpeg": 5358,
	"./blouse/designs/blouse-front/blouse-designs-132.jpeg": 9419,
	"./blouse/designs/blouse-front/blouse-designs-133.jpeg": 8260,
	"./blouse/designs/blouse-front/blouse-designs-134.jpeg": 5486,
	"./blouse/designs/blouse-front/blouse-designs-135.jpeg": 3258,
	"./blouse/square-vfront/ChatGPT Image Aug 27, 2026, 10_53_20 AM.png": 5121,
	"./blouse/square-vfront/ChatGPT Image Aug 27, 2026, 10_55_34 AM.png": 1094,
	"./blouse/square-vfront/ChatGPT Image Aug 27, 2026, 10_56_35 AM.png": 2826,
	"./blouse/square-vfront/ChatGPT Image Aug 27, 2026, 10_57_26 AM.png": 8251,
	"./blouse/square-vfront/ChatGPT Image Aug 27, 2026, 10_58_22 AM.png": 912,
	"./half-saree/half-saree-100.png": 2870,
	"./half-saree/half-saree-102.png": 2948,
	"./half-saree/half-saree-103.png": 6845,
	"./half-saree/half-saree-104.png": 1986,
	"./half-saree/half-saree-105.png": 6811,
	"./half-saree/half-saree-106.png": 4832,
	"./half-saree/half-saree-107.png": 2953,
	"./kids/Kids-Girl-001-100.jpeg": 6864,
	"./kids/Kids-Girl-001-101.png": 2878,
	"./kids/Kids-Girl-001-102.png": 8629,
	"./kids/Kids-Girl-001-103.png": 6364,
	"./kids/Kids-Girl-001-104.png": 2611,
	"./kids/Kids-Girl-001-105.png": 8506,
	"./lehenga/Lehanga-001-100.jpeg": 5619,
	"./lehenga/Lehanga-001-102.png": 1904,
	"./lehenga/Lehanga-001-103.png": 3081,
	"./lehenga/Lehanga-001-104.png": 6902,
	"./lehenga/Lehanga-001-105.png": 3231,
	"./lehenga/Lehanga-001-106.png": 8580,
	"./lehenga/Lehanga-001-107.png": 8525,
	"./painting/design-001/thanjavur-painting-001-100.png": 8831,
	"./painting/design-001/thanjavur-painting-001-101.png": 1894,
	"./painting/design-001/thanjavur-painting-001-102.png": 5869,
	"./painting/design-002/thanjavur-painting-002-101.png": 2868,
	"./painting/design-002/thanjavur-painting-002-102.png": 7519,
	"./painting/design-003/thanjavur-painting-003-100.png": 6867,
	"./painting/design-003/thanjavur-painting-003-101.png": 1658,
	"./painting/girl-n-cow/thanjavur-painting-004-100.png": 6245,
	"./saree-falls/saree-falls-101.png": 3345,
	"./saree-falls/saree-falls-102.png": 2762,
	"./saree-falls/saree-falls-104.png": 6748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1793;